// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FOFR","type":"styles_type__24I74","choices":"styles_choices__2JvDp"};